import { useMemo } from 'react'
import { useTheme } from '../../../context/theme'
import { chartPalette } from '../../../utilities/dashboard'

// Cores dos gráficos no tema da tela e na cor do menu: { chart, age, sex } (utilities/dashboard). O recharts recebe hex, e não
// var() do CSS
export default function useChartColors() {
  const { theme, brandColor } = useTheme()
  return useMemo(() => chartPalette(theme, brandColor), [theme, brandColor])
}
